import { AxiosResponse } from 'axios';
import { snakeCaseKeys } from 'helpers/utils';
import { get, post, remove } from 'services/api';
import { IJewishnessFormData } from 'views/public/JewishnessView/components/JewishnessForm/types';

export const getAll = (
  limit: number,
  page: number,
  search: string,
  sortKey: string,
  sortType: string,
): Promise<AxiosResponse> =>
  get(
    `jewishness?limit=${limit}&page=${page}&search=${search}&sortKey=${sortKey}&sortType=${sortType}`,
  );

export const getForm = (): Promise<AxiosResponse> => get('jewishness/form');

export const getOne = (id: string): Promise<AxiosResponse> => get(`jewishness/${id}`);

export const save = (data: IJewishnessFormData, id: string): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append(
    'person',
    JSON.stringify(snakeCaseKeys(data.person as unknown as Record<string, unknown>)),
  );
  if (data.person?.idCardFile) formData.append('person_id_card_file', data.person.idCardFile);
  if (data.person?.idCardBackFile)
    formData.append('person_id_card_back_file', data.person.idCardBackFile);
  if (data.person?.birthCertificateFile)
    formData.append('person_birth_certificate_file', data.person.birthCertificateFile);
  if (data.person?.ketubaFile) formData.append('person_ketuba_file', data.person.ketubaFile);
  if (data.person?.marriageCertificateFile)
    formData.append('person_marriage_certificate_file', data.person.marriageCertificateFile);
  if (data.person?.getFile) formData.append('person_get_file', data.person.getFile);
  if (data.person?.parents?.father?.idCardFile)
    formData.append('person_parents_father_id_card_file', data.person.parents.father.idCardFile);
  if (data.person?.parents?.father?.idCardBackFile)
    formData.append(
      'person_parents_father_id_card_back_file',
      data.person.parents.father.idCardBackFile,
    );
  if (data.person?.parents?.mother?.idCardFile)
    formData.append('person_parents_mother_id_card_file', data.person.parents.mother.idCardFile);
  if (data.person?.parents?.mother?.idCardBackFile) {
    formData.append(
      'person_parents_mother_id_card_back_file',
      data.person.parents.mother.idCardBackFile,
    );
  }
  if (data.person?.parents?.ketubaFile)
    formData.append('person_parents_ketuba_file', data.person.parents.ketubaFile);
  if (data.person?.parents?.marriageCertificateFile)
    formData.append(
      'person_parents_marriage_certificate_file',
      data.person.parents.marriageCertificateFile,
    );
  if (data.person?.grandParents?.paternalKetubaFile)
    formData.append(
      'person_grand_parents_paternal_ketuba_file',
      data.person.grandParents.paternalKetubaFile,
    );
  if (data.person?.grandParents?.paternalMarriageCertificateFile)
    formData.append(
      'person_grand_parents_paternal_marriage_certificate_file',
      data.person.grandParents.paternalMarriageCertificateFile,
    );
  if (data.person?.grandParents?.paternalCemeteryBurialCertificateFile)
    formData.append(
      'person_grand_parents_paternal_cemetery_burial_certificate_file',
      data.person.grandParents.paternalCemeteryBurialCertificateFile,
    );
  if (data.person?.grandParents?.maternalKetubaFile)
    formData.append(
      'person_grand_parents_maternal_ketuba_file',
      data.person.grandParents.maternalKetubaFile,
    );
  if (data.person?.grandParents?.maternalMarriageCertificateFile)
    formData.append(
      'person_grand_parents_maternal_marriage_certificate_file',
      data.person.grandParents.maternalMarriageCertificateFile,
    );
  if (data.person?.grandParents?.maternalCemeteryBurialCertificateFile)
    formData.append(
      'person_grand_parents_maternal_cemetery_burial_certificate_file',
      data.person.grandParents.maternalCemeteryBurialCertificateFile,
    );
  data.person?.witnesses?.forEach((witness, i) => {
    formData.append(`person_witnesses_id_card_files[${i}]`, witness.idCardFile ?? '');
    formData.append(`person_witnesses_id_card_back_files[${i}]`, witness.idCardBackFile ?? '');
    formData.append(`person_witnesses_ketuba_files[${i}]`, witness.ketubaFile ?? '');
    formData.append(
      `person_witnesses_marriage_certificate_files[${i}]`,
      witness.marriageCertificateFile ?? '',
    );
  });
  if (
    data.spouse.lastName &&
    data.spouse.firstName &&
    data.spouse.idCard &&
    data.spouse.country &&
    data.spouse.birthdate &&
    data.spouse.tribe
  ) {
    formData.append(
      'spouse',
      JSON.stringify(snakeCaseKeys(data.spouse as unknown as Record<string, unknown>)),
    );
  }
  if (data.spouse?.idCardFile) formData.append('spouse_id_card_file', data.spouse.idCardFile);
  if (data.spouse?.idCardBackFile)
    formData.append('spouse_id_card_back_file', data.spouse.idCardBackFile);
  if (data.comments) formData.append('comments', data.comments);
  if (id) formData.append('_method', 'PUT');
  return post(`jewishness${!id ? '' : `/${id}`}`, formData, { transformRequest: () => formData });
};

export const softDelete = (id: string): Promise<AxiosResponse> => remove(`jewishness/${id}`);

export const softDeleteFile = (id: string, fileId: string): Promise<AxiosResponse> =>
  remove(`jewishness/${id}/files/${fileId}`);
